var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['form-panel', _vm.panelClass, _vm.small ? 'form-panel-small' : '']},[_c('div',{staticClass:"form-panel-heading"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"form-panel-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }